import App from 'app/app.js';
import 'app/service/RouterService.js';
import 'app/store/MessageStore.js';

function LtStudentPortraitInformationCtrl($scope, RouterService, $filter, MessageStore) {
  this.getGetStartedPath = function () {
    return RouterService.paths.GET_STARTED;
  };

  this.getFormMessages = function () {
    return MessageStore.getFormMessages();
  };

  this.submit = function () {
    $scope.onSubmit();
  };

  this.getPlaceholder = function (key) {
    return $filter('ltTranslateFilter')(key);
  };
}

App.controller('LtStudentPortraitInformationCtrl', [
  '$scope',
  'RouterService',
  '$filter',
  'MessageStore',
  LtStudentPortraitInformationCtrl
]);
